export default {
  None: -1, //mặc định
  ZeroToMinus: 0, //nếu giá trị là số không thì trả về '-'
  ZeroToZero: 1, //nếu giá trị là số không thì trả về 0
  ZeroToEmpty: 2, //nếu giá trị là số không thì trả về trống
  EmptyToMinus: 3, //nếu giá trị là trống thì trả về '-'
  EmptyToZero: 4, //nếu giá trị là trống thì trả về 0
  EmptyToEmpty: 5, //nếu giá trị là trống thì trả về trống
};
